const EMAIL_SEPARATOR = '@'

export const getEmailLocalPart = (email: string): string => email.split(EMAIL_SEPARATOR)[0] ?? ''
